export enum StocklistDecreaseAmountDescriptionType {
  Error = 'Error',
  Break = 'Break',
  Custom = 'Custom',
}
